/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {getData, protectedPostData} from "../../api/Interface";
import {GlobalAPIRoutes, PublicAPIRoutes} from "../../api/APIRoutes";
import {Button, Form, Input} from "antd";
import CkEditorCmp from "../../components/global/CkEditorCmp";
import Loader from "../../components/global/loaders/Loader";
import loadingWhite from "../../assets/images/loading_white.svg";
import {openNotificationWithIcon} from "../../Helper";
import VideoPlayer from "../../components/public/main/VideoPlayer";
import placeholder from "../../assets/images/placeholder.png";
import moment from "jalali-moment";

const EventItem = () => {

    let {id} = useParams();

    const [loading, setLoading] = useState(true);
    const [itemDetail, setItemDetail] = useState(true);
    const [videos, setVideos] = useState([]);
    const [itemCategories, setItemCategories] = useState([]);
    const [content, setContent] = useState('');
    const [isFollow, setIsFollow] = useState('');

    useEffect(() => {
        getVgItem().then(r =>
            setLoading(false)
        );

    }, [id]);

    useEffect(()=>{
            checkFollow()
        },[itemDetail]);

    const getVgItem = async () => {
        setLoading(true);
        let response = await getData(PublicAPIRoutes.GetEventsItem + `/${id}`);
        if (response && response.data) {
            setItemDetail(response.data);
            if (response.data.category) {
                let cats = [];
                response.data.category.map((item) => {
                    cats.push(item.id)
                });
                setItemCategories(cats);
            }
        }
    };

    const follow = async() => {
        // setLoading(true);
        const data = new FormData();
        data.append("following_id", itemDetail.user_id);

        let response = await protectedPostData(PublicAPIRoutes.MyEventFollow, data);
        if (response) {
            setIsFollow('true')
        }

        openNotificationWithIcon('success', "موفق", "عملیات با موفقیت انجام شد");
        // setLoading(false);
    }

    const unfollow = async() => {
        // setLoading(true);
        const data = new FormData();
        data.append("following_id", itemDetail.user_id);

        let response = await protectedPostData(PublicAPIRoutes.MyEventUnFollow, data);
        if (response) {
            setIsFollow('false')
        }

        openNotificationWithIcon('success', "موفق", "عملیات با موفقیت انجام شد");
        // setLoading(false);
    }

    const checkFollow = async() => {
        // setLoading(true);
        const data = new FormData();
        data.append("following_id", itemDetail.user_id);

        let response = await protectedPostData(PublicAPIRoutes.MyEventCheckFollow, data);
        if (response) {
            setIsFollow(response.data)
        }

        // setLoading(false);
    }

    const sendPost = async (e) => {
        setLoading(true);
        const data = new FormData();
        data.append("author", e.author);
        data.append("email", e.email);
        data.append("title", e.title);
        data.append("content", content);
        data.append("reply_to", 0);
        data.append("videogram_id", itemDetail.id);

        let response = await protectedPostData(PublicAPIRoutes.AddVgCooment, data);
        if (response) {
        }

        openNotificationWithIcon('success', "موفق", "نظر شما با موفقیت ثبت گردید.");
        setLoading(false);
    };

    const handleEditorChange = (content) => {
        setContent(content);
    };

    const videoJsOptions = {
        controls: true,
    };

    return (
        <>
            {!loading &&
            <>
                <div className="row">
                    <div className="col-7 ">
                        <div className="bg-white borderRadiusOne my-3 py-5">

                            <div className="vg-item"
                                 style={{
                                     background: `url(${itemDetail.thumb_image !== null ?
                                         itemDetail.origin_image.s3_status === 2
                                             ? itemDetail.origin_image.s3_file
                                             :  itemDetail.origin_image.url
                                         : '#808080'})`,
                                 }}
                            >
                                <div className="dark-overlay b-15">
                                    <div className="vg-title">
                                        <p className="font-weight-bold" style={{fontSize: 22}}>{itemDetail.title}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-5 ">
                        <div className="bg-white borderRadiusOne my-3 py-5">
                            <table className="table">
                                <tr>
                                    <td>برگزار کننده : </td>
                                    <td>{itemDetail.user.name}</td>
                                </tr>
                                <tr>
                                    <td>قیمت : </td>
                                    <td>{itemDetail.price} تومان</td>
                                </tr>
                                <tr>
                                    <td>دنبال کننده : </td>
                                    <td>
                                        {isFollow && isFollow === 'true' ?

                                            <button className="btn btn-success" onClick={unfollow}>دنبال نکنید </button>
                                            :
                                            <button className="btn btn-success" onClick={follow}> دنبال کنید</button>

                                        }
                                    </td>
                                </tr>

                                <tr>
                                    <td>خرید</td>
                                    <td>
                                        {localStorage.getItem("zibatran-user-data") && JSON.parse(localStorage.getItem("zibatran-user-data")).code !== "" ?
                                            <button onClick={(event) =>{ event.preventDefault(); window.location.href='/checkout/event/'+id}} className="btn btn-success">پرداخت</button>
                                            :
                                            <button onClick={(e) => {
                                                e.preventDefault();window.location.href='/auth?ref=event-'+id
                                            }} className="btn btn-success">ورود و عضویت</button>
                                        }
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="bg-white borderRadiusOne my-3 py-5">
                    <div className="row">
                        <div className="col-12 ">
                            <p dangerouslySetInnerHTML={{__html: itemDetail.description}}/>
                        </div>
                        { itemDetail.sessions &&
                                 <>
                                    <div className="col-12 my-5">

                                        <br/>
                                        <hr/>
                                        <h4>جلسات :</h4>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>آدرس</th>
                                                    <th>تاریخ</th>
                                                    <th>نوع جلسه</th>
                                                    <th>توضیح</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {itemDetail.sessions.map((item, key) =>

                                                <tr>
                                                    <td>{item.address}</td>
                                                    <td>{moment.unix(item.start_time).locale("fa").format("LLLL")}</td>
                                                    <td>{item.type===1 ? 'حضوری' : 'مجازی'} </td>
                                                    <td><p dangerouslySetInnerHTML={{__html: item.description}}/></td>
                                                </tr>

                                            )}
                                            </tbody>

                                                </table>
                                        {/*{itemDetail.sessions.map((item, key) =>*/}
                                        {/*    <>*/}

                                        {/*        <div className="float-left">*/}
                                        {/*            آدرس : {item.address}*/}
                                        {/*        </div>*/}
                                        {/*        <div className="float-right">*/}
                                        {/*        تاریخ : {moment.unix(item.start_time).locale("fa").format("YYYY/MM/DD HH:mm:ss")}*/}
                                        {/*        </div>*/}
                                        {/*        <br/>*/}
                                        {/*        <h5>توضیح :</h5>*/}
                                        {/*        <p dangerouslySetInnerHTML={{__html: item.description}}/>*/}
                                        {/*        <hr/>*/}
                                        {/*    </>*/}
                                        {/*)}*/}

                                    </div>
                                </>
                        }

                        {/*<div className="col-12 my-5 float-right">*/}
                        {/*    {localStorage.getItem("zibatran-user-data") && JSON.parse(localStorage.getItem("zibatran-user-data")).code !== "" ?*/}
                        {/*        <button onClick={(event) =>{ event.preventDefault(); window.location.href='/checkout/event/'+id}} className="btn btn-success">خرید</button>*/}
                        {/*        :*/}
                        {/*        <button onClick={(e) => {*/}
                        {/*            e.preventDefault();window.location.href='/auth?ref=event-'+id*/}
                        {/*        }} className="btn btn-success">ورود و عضویت</button>*/}
                        {/*    }*/}
                        {/*</div>*/}
                    </div>
                </div>

                <div className="bg-white borderRadiusOne my-3 py-5">
                    <div className="row">
                        <div className="col-12 mb-5 py-3 bg-light">
                            <span className="font-weight-bolder h3">نظرات کاربران</span>
                        </div>

                        <div className="col-12 my-2">
                            <h5>نظر جدید ثبت کنید :</h5>
                        </div>
                        <Form
                            className="row col-xl-12 col-lg-12 col-md-12 col-12 pt-2"
                            style={{backgroundColor: '#FFFFFF', borderRadius: '20px', marginTop: 20}}
                            onFinish={!loading && sendPost}
                        >

                            <Form.Item
                                style={{textAlign: 'right', direction: 'rtl'}}
                                className="col-xl-4 col-lg-4 col-md-4 col-12 pr-2 pl-2 "
                                name="author"
                                rules={[
                                    {
                                        required: true,
                                        message: 'تکمیل این فیلد الزامیست',
                                    },
                                ]}
                            >
                                <Input
                                    className="inputStyleOne"
                                    placeholder="نام شما"
                                    disabled
                                />

                            </Form.Item>

                            <Form.Item
                                style={{textAlign: 'right', direction: 'rtl'}}
                                className="col-xl-4 col-lg-4 col-md-4 col-12 pr-2 pl-2 "
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: 'تکمیل این فیلد الزامیست',
                                        type: 'email'
                                    },
                                ]}
                            >
                                <Input
                                    className="inputStyleOne"
                                    placeholder="ایمیل شما"
                                    disabled
                                />

                            </Form.Item>

                            <Form.Item
                                style={{textAlign: 'right', direction: 'rtl'}}
                                className="col-xl-4 col-lg-4 col-md-4 col-12 pr-2 pl-2 "
                                name="title"
                                rules={[
                                    {
                                        required: true,
                                        message: 'تکمیل این فیلد الزامیست',
                                    },
                                ]}
                            >
                                <Input
                                    className="inputStyleOne"
                                    placeholder="عنوان"
                                    disabled
                                />

                            </Form.Item>

                            <Form.Item
                                style={{textAlign: 'right'}}
                                className="col-xl-12 col-lg-12 col-md-12 col-12 pr-2 pl-2"
                                name="content"

                            >
                                <span>متن خود را وارد کنید</span>
                                <CkEditorCmp
                                    id={"content"}
                                    onChange={handleEditorChange}
                                    disabled
                                />

                            </Form.Item>

                            <Form.Item className="col-12 text-center">
                                <Button className="buttonStyleOne col-4" htmlType="submit" disabled>

                                    {loading ?

                                        <img src={loadingWhite}
                                             alt="Loading ..."
                                             width="40"
                                             height="22"
                                        />
                                        :
                                        "ثبت"
                                    }
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>

                {loading && <Loader/>}


            </>
            }
        </>
    )
};

export default EventItem;
